var __TEMP__ = require('./ary.js');var ary = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Creates a function that accepts up to one argument, ignoring any
 * additional arguments.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.unary(parseInt));
 * // => [6, 8, 10]
 */
function unary(func) {
  return ary(func, 1);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = unary;
